import { ApiRequestEnum } from 'src/app/core/enums/api-request.enum';
import { ApiService } from 'src/app/core/services/api.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ItemCategoryService {
	constructor(
		private apiService: ApiService,
	) {
	}

	GetAllItemCategory(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllItemCategory, params);
	}

	GetAllCollectionType(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllCollectionType, params);
	}

	GetAllProductType(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllProductType, params)
	}

	GetAllOccasionType(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllOccasionType, params)
	}

	GetFestiveOccasionName(name: any) {
		return this.apiService.get(ApiRequestEnum.GetFestiveOccasionName.replace('{{name}}', name))
	}

	GetAllFestiveOccasionItems(params: any) {
		return this.apiService.post(ApiRequestEnum.GetAllFestiveOccasionItems, params)
	}
}
